/**
 * @license lucide v0.294.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const Snowflake = [
  "svg",
  defaultAttributes,
  [
    ["line", { x1: "2", x2: "22", y1: "12", y2: "12" }],
    ["line", { x1: "12", x2: "12", y1: "2", y2: "22" }],
    ["path", { d: "m20 16-4-4 4-4" }],
    ["path", { d: "m4 8 4 4-4 4" }],
    ["path", { d: "m16 4-4 4-4-4" }],
    ["path", { d: "m8 20 4-4 4 4" }]
  ]
];

export { Snowflake as default };
//# sourceMappingURL=snowflake.js.map
